import { getTheme } from 'utils/themes';
import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for line chart */
//   data: [],
//   /* Set additional options for line chart. */
//   options: {},
//   /** Override color of sparkline. */
//   sparklineColor: string,
//   /* Theme of the line chart. */
//   theme: string,
// };

export default function Sparkline(props) {
  const { className, data, options, sparklineColor, theme, ...otherProps } = props;

  const themeDef = getTheme(theme);

  const axisStyles = {
    visible: false,
  };

  const defaultOptions = {
    chart: {
      height: 50,
    },
    colors: (sparklineColor && [sparklineColor]) || themeDef.chartColors,
    legend: {
      enabled: false,
    },
    series: {
      marker: {
        enabled: false,
      },
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    tooltip: {
      enabled: false,
    },
    xAxis: axisStyles,
    yAxis: axisStyles,
  };

  return (
    <BaseChart
      className={className}
      chartType="line"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      {...otherProps}
    />
  );
}
